import React from 'react';
import { Tab, Box, Tabs } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  sx?: object;
}

export default function TabsComponent(props: TabPanelProps) {
  const { children, value, index, sx, ...other } = props;
  const boxStyles = {
    '& > div': {
      padding: "24px 0px",
    },
  };

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ mt: 1, ...sx }}>{children}</Box>}
    </div>
  );
}
